import $http from "../../axios";

//Obtener los departamentos
export async function fetchDepartments({ commit }, requestParameters) {
  await $http
    .get("/api/departamentos", requestParameters)
    .then(response => {
      commit("setDepartments", response.data.data);
    })
    .catch(error => {
      swal({
        title: "error",
        text: error.message,
        type: "error"
      });
      commit("DepartmentError", error.message);
    });
}



// WEBPACK FOOTER //
// ./src/modules/departments/actions.js